document.addEventListener('DOMContentLoaded', function () {
    const colors = ['#DD4E41', '#F4BA4C', '#66A5D3'];
    let currentColorIndex = 0;
    let currentMobileColorIndex = 0;

    if(document.querySelector('.hero-carrousel') != null){
        const carousel = document.getElementById('carousel');
        let slides = Array.from(carousel.children);
        const headings = document.querySelectorAll('.hero-carrousel__slide--heading');

        let currentIndex = 0;
        let headingIndex = 0;

        const totalSlides = slides.length;
        const wrapper = document.querySelector('.hero-carrousel__wrapper');
        let fullView = false;

        //initialisations for phone component of carrousel
        const popCornPhone = document.querySelector('.hero-carrousel__slide--phone--background');
        let popCornWrapper = document.querySelector('.hero-carrousel__slide--phone--wrapper');
        let popCornElements = document.querySelectorAll('.hero-carrousel__slide--phone--hero-item');
        let phoneCardColors = [];
        let popcornIndex = 0;

        popCornElements.forEach((item, index) => {
            let itemColor = item.getAttribute('data-hex');
            phoneCardColors.push(itemColor);
        });

        popCornPhone.style.backgroundColor = phoneCardColors[popcornIndex];

        let phoneWrapperWidth = popCornElements[0].clientWidth * popCornElements.length + (popCornElements.length * 10);
        popCornWrapper.style.width = phoneWrapperWidth + "px";
        popCornElements[0].classList.add('current');

        window.movePhoneContent = function() {
            let movementWidth = popCornElements[0].clientWidth - 2;
            popcornIndex = (popcornIndex + 1) % popCornElements.length;
            popCornPhone.style.backgroundColor = phoneCardColors[popcornIndex];

            if (popcornIndex === popCornElements.length - 1) {
                let popCornCopy = popCornElements[0];
                popCornElements[0].remove();
                popCornWrapper.appendChild(popCornCopy);

                if(popCornElements.length > 4){
                    let offset = popCornElements.length - 4;
                    popcornIndex = 1 + offset;
                } else {
                    popcornIndex = 1;
                }

                popCornWrapper.style.transition = 'none';
                popCornWrapper.style.left = '-'+ (movementWidth * popcornIndex) +'px'; // Reset the left position immediately
                popCornElements = document.querySelectorAll('.hero-carrousel__slide--phone--hero-item');
                phoneCardColors.push(phoneCardColors.shift());

                popCornWrapper.offsetHeight; //force a reset

                // Re-enable transition for smooth animation
                popCornWrapper.style.transition = 'left 0.5s ease';
                popCornWrapper.style.left = '-' + movementWidth * popcornIndex + 'px';
                movePhoneContent();
            } else {
                popCornElements.forEach(item => {
                    item.classList.remove('current');
                });
                popCornElements[popcornIndex].classList.add('current');
                popCornWrapper.style.left = '-' + movementWidth * popcornIndex + 'px';
            }
        };

        // end initialisations for phone component of carrousel

        function showNextSlide() {
            currentIndex++;

            if (currentIndex >= totalSlides) {
                currentIndex = 2;
                const firstSlide = slides.shift();
                carousel.appendChild(firstSlide);
                slides.push(firstSlide);
                carousel.style.transition = 'none';
                carousel.style.transform = `translateX(-50vw)`;
                carousel.offsetHeight;

                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        carousel.style.transition = 'transform 1s ease';
                        carousel.style.transform = `translateX(-${currentIndex * 50}vw)`;
                    });
                });
            } else {
                carousel.style.transform = `translateX(-${currentIndex * 50}vw)`;
            }

            if(fullView === false){
                fullView = true;

                if (headingIndex < headings.length) {
                    headings[headingIndex].classList.remove('visible');
                }

                if(headingIndex >= headings.length){
                    headingIndex = 0;
                }else {
                    headingIndex++;
                }
            }else {
                fullView = false;
                if(headingIndex >= headings.length){
                    headingIndex = 0;
                }

                headings[headingIndex].classList.add('visible');
                currentColorIndex = (currentColorIndex + 1) % colors.length;
                wrapper.style.backgroundColor = colors[currentColorIndex];
                movePhoneContent();
            }
        }

        setInterval(showNextSlide, 3000);
    }
    //mobile carrousel underneath
    if (document.querySelector('.hero-carrousel-mobile') != null && document.querySelector('.hero-carrousel-mobile').style.display !== 'none') {
        const carousel = document.getElementById('carousel-mobile');
        let slides = Array.from(carousel.children);
        let headings = Array.from(document.querySelectorAll('.hero-carrousel-mobile__slide--heading'));

        var headingIndex = 0;

        const wrapper = document.querySelector('.hero-carrousel-mobile__wrapper');
        let currentIndexMobile = 0;
        const totalSlides = slides.length;

        //popcorn carrousel -- initialise
        let mobileCarrouselPopcornWrapper = document.querySelector('.hero-carrousel-mobile__slide--popcorn');
        let mobileCarrouselPopcornItems = document.querySelectorAll('.hero-carrousel__slide--mobile--hero-item');
        let mobileCarrouselPopcornItemsCount = mobileCarrouselPopcornItems.length;
        let mobileCarrouselPopcornItemsCountIndex = 0;
        //set width for popcorncarrousel
        mobileCarrouselPopcornWrapper.style.width = mobileCarrouselPopcornItemsCount * 100 + 'vw';

        window.shiftMobilePopcornItems = function() {
            // Move the content inside the mobileCarrouselPopcornWrapper 100vw to the left each tick
            mobileCarrouselPopcornItemsCountIndex = (mobileCarrouselPopcornItemsCountIndex + 1) % mobileCarrouselPopcornItemsCount;

            if (mobileCarrouselPopcornItemsCountIndex === mobileCarrouselPopcornItemsCount - 1) {
                let popCornCopy = mobileCarrouselPopcornItems[0];
                mobileCarrouselPopcornItems[0].remove();
                mobileCarrouselPopcornWrapper.appendChild(popCornCopy);

                if(mobileCarrouselPopcornItems.length > 4){
                    let offset = mobileCarrouselPopcornItems.length - 4;
                    mobileCarrouselPopcornItemsCountIndex = 1 + offset;
                } else {
                    mobileCarrouselPopcornItemsCountIndex = 1;
                }

                mobileCarrouselPopcornWrapper.style.transition = 'none';
                mobileCarrouselPopcornWrapper.style.left = '-' + (100 * mobileCarrouselPopcornItemsCountIndex) + 'vw'; // Reset the left position immediately
                mobileCarrouselPopcornItems = document.querySelectorAll('.hero-carrousel__slide--mobile--hero-item');

                mobileCarrouselPopcornWrapper.offsetHeight; // Force a reset

                // Re-enable transition for smooth animation
                mobileCarrouselPopcornWrapper.style.transition = 'left 0.5s ease';
                mobileCarrouselPopcornWrapper.style.left = '-' + 100 * mobileCarrouselPopcornItemsCountIndex + 'vw';
                shiftMobilePopcornItems();
            } else {
                mobileCarrouselPopcornWrapper.style.transition = 'left 0.5s ease';
                mobileCarrouselPopcornWrapper.style.left = '-' + 100 * mobileCarrouselPopcornItemsCountIndex + 'vw';
            }
        }

        // Clone the first slide and append it to the end
        const firstSlideClone = slides[0].cloneNode(true);
        carousel.appendChild(firstSlideClone);

        wrapper.style.backgroundColor = colors[currentMobileColorIndex];

        window.showHeadingAtCurrentIndex = function() {
            // Hide all headings
            headings.forEach(item => item.classList.remove('visible'));

            // Show the heading at the current index
            headings[headingIndex].classList.add('visible');

            // Update the heading index
            headingIndex = (headingIndex + 1) % headings.length;
        }

        showHeadingAtCurrentIndex();

        function showNextMobileSlide() {
            currentIndexMobile++;
            updateCarousel();
            shiftMobilePopcornItems();

            if (currentIndexMobile >= totalSlides) {
                setTimeout(resetCarousel, 1000); // 1 second matches the transition duration
            }

            updateUIElements();
        }

        function updateCarousel() {
            const translateXValue = currentIndexMobile >= totalSlides ? totalSlides * 200 : currentIndexMobile * 200;
            setTransform(carousel, `translateX(-${translateXValue}vw)`);
        }

        function resetCarousel() {
            carousel.style.transition = 'none';
            carousel.style.transform = 'translateX(0)';
            currentIndexMobile = 0;
        }

        function updateUIElements() {
            headings[headingIndex].classList.add('visible');
            currentMobileColorIndex = (currentMobileColorIndex + 1) % colors.length;
            wrapper.style.backgroundColor = colors[currentMobileColorIndex];
            showHeadingAtCurrentIndex();
        }

        function setTransform(element, transformValue) {
            element.style.transition = 'transform 1s ease';
            element.style.transform = transformValue;
        }

        setInterval(showNextMobileSlide, 3000);
    }

    const headerWrapper = document.querySelector('.home__header__wrapper');

    if(headerWrapper != null){
        window.addEventListener('scroll', () => {
            if (window.scrollY > 766) {
                headerWrapper.classList.remove('home__header__wrapper--hidden');
            } else {
                headerWrapper.classList.add('home__header__wrapper--hidden');
            }
        });
    }
});
